import type { LeadFlowDocument } from "../types";

import { DEFAULT_STEP_TRANSITION_VARIANT } from "@homeinstead/schemas";

/**
 * The view transition class for a flow's step changes, or `none`
 * when transitions are off. The variant and speed are separate classes so
 * `lead-flow-step-transition.css` keeps one rule per variant and per speed.
 * Moving back to an earlier step adds a class that mirrors the variant's
 * motion. Unset fields take Studio's initial values.
 */
function getStepTransitionClassName(
  stepTransition: LeadFlowDocument["stepTransition"],
  direction: "back" | "forward",
): string {
  if (stepTransition?.enabled === false) {
    return "none";
  }

  const variant = stepTransition?.variant ?? DEFAULT_STEP_TRANSITION_VARIANT;
  const speed = stepTransition?.speed ?? "default";
  const directionClassName = direction === "back" ? " lead-flow-step-back" : "";

  return `lead-flow-step-${variant} lead-flow-step-speed-${speed}${directionClassName}`;
}

export { getStepTransitionClassName };
